import React from "react";
import { useState } from "react";
import {
  Button,
  Card,
  FormControl,
  Grid,
  InputAdornment,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import NumberFormatting from "../../helper/NumberFormatting";
import { useEffect } from "react";
import {
  getStockOperationalGoodsById,
  stockOperationalGoodsActions,
  updateStockOperationalGoods,
} from "../../../redux/reducer/stock-operational-goods/stockOperationalGoodsReducer";
import { getGoodsOperational } from "../../../redux/reducer/goodsOperational/goodsOperationalReducer";

const useStyles = makeStyles(() => ({
  headerClass: {
    display: "flex",
    alignItems: "flex-start",
    width: "100%",
    flexDirection: "column",
    padding: "5px",
    margin: "10px 0px",
    background: "#F2F2F2",
  },
  dividerStyle: {
    border: "1px solid #386E5B",
    width: "100%",
    margin: "5px 0px",
  },
  footerButton: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "flex-end",
    marginBottom: "10px",
    width: "99%",
  },
  tableHeader: {
    background: "#ddd",
    textAlign: "center",
    borderBottom: "1px solid #D1CDCD",
    padding: "1em",
  },
  tableCell: {
    background: "#ddd",
    borderBottom: "1px solid #D1CDCD",
    padding: "5px 0px",
  },
  actionButtonEdit: {
    backgroundColor: "#dde0f0",
    color: "#A0A3B3",
    fontSize: "25px",
    textAlign: "center",
    borderRadius: "5px",
    margin: "auto",
    cursor: "pointer",
    "&:hover": {
      background: "#7dbda9",
    },
  },
}));

export default function AdminStockVegetablesEdit() {
  // Navigate
  const navigate = useNavigate();
  const { id } = useParams();

  // Styling
  const styles = useStyles();

  // Redux Data
  const dispatch = useDispatch();
  const token = useSelector((state) => state.auth.token);
  const user = useSelector((state) => state.auth.dataToken);
  const goodsOperational = useSelector((state) => state.goodsOperational.data);
  const data = useSelector((state) => state.stockOperationalGoods.data);

  // Local State
  const [formData, setFormData] = useState({
    goodsOperationalId: "",
    stockIn: "",
    stockOut: "",
    stockTotal: "",
    description: "",
  });

  const [fetch, setFetch] = useState(true);

  useEffect(() => {
    if (fetch) {
      let x = data.docs.findIndex((item) => item._id === id);
      if (x > -1) {
        setFormData({
          goodsOperationalId: data.docs[x].goodsOperationalId
            ? data.docs[x].goodsOperationalId._id
            : "",
          nameOfGoods: data.docs[x].goodsOperationalId
            ? data.docs[x].goodsOperationalId.nameOfGoods
            : "",
          stockIn: data.docs[x].stockIn ? data.docs[x].stockIn : "",
          stockOut: data.docs[x].stockOut ? data.docs[x].stockOut : "",
          stockTotal: data.docs[x].stockTotal ? data.docs[x].stockTotal : "",
          description: data.docs[x].description ? data.docs[x].description : "",
        });
      }
      setFetch(false);
    }
  }, [fetch]);

  // Basic Handle Change
  const handleChange = (e) => {
    if (e.target.name === "stockIn") {
      setFormData({
        ...formData,
        ["stockIn"]: parseInt(e.target.value) ,
        ["stockOut"]: 0,
      });
    } else if (e.target.name === "stockOut") {
      setFormData({
        ...formData,
        ["stockIn"]: 0,
        ["stockOut"]: parseInt(e.target.value),
      });
    } else {
      setFormData({
        ...formData,
        [e.target.name]: e.target.value,
      });
    }
  };


  const handleSubmitAll = (e) => {
    e.preventDefault();
    Swal.fire({
      title: `Mohon dicek kembali data yang akan di input`,
      icon: "warning",
      buttons: true,
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Tambah",
      cancelButtonText: "Batal",
    }).then((confirm) => {
      if (confirm.isConfirmed) {
        let data = {
          id: id,
          value: {
            goodsOperationalId: formData.goodsOperationalId,
            stockIn: formData.stockIn,
            stockOut: formData.stockOut,
            stockTotal: formData.stockTotal,
            description: formData.description,
            createdBy: user.username,
            updatedBy: user.username,
          },
          token: token,
        };
        dispatch(updateStockOperationalGoods(data)).then((res) => {
          if (res.payload.status === 200) {
            let dataGetById = {
              id: res.payload.data._id,
              token: token,
            };
            dispatch(getStockOperationalGoodsById(dataGetById)).then(
              (result) => {
                dispatch(
                  stockOperationalGoodsActions.editStockOperationalGoods(
                    result.payload.data
                  )
                );
                toast.success(res.payload.message);
                navigate("/admin/stock-barang-operational");
              }
            );
          }
        });
      } else {
        return;
      }
    });
  };

  const loadMore = (value) => (event) => {
    if (
      event.target.scrollHeight - event.target.scrollTop < 300 &&
      event.target.scrollTop < 100
    ) {
      if (
        goodsOperational.totalDocs !== goodsOperational.docs.length &&
        value === 1
      ) {
        const getData = {
          params: {
            limit: goodsOperational.limit + 10,
            page: 1,
          },
          token: token,
        };
        dispatch(getGoodsOperational(getData));
      }
    }
  };

  return (
    <Grid container>
      <ToastContainer />
      <Card className={styles.headerClass}>
        <Typography fontSize={20} fontWeight={600} color={"#0A543B"}>
          EDIT STOCK BARANG
        </Typography>
      </Card>
      <Card className={styles.headerClass}>
        <form
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            marginTop: "10px",
          }}
          onSubmit={handleSubmitAll}
        >
          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              BARANG
            </Typography>
            <TextField
              select
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="goodsOperationalId"
              onChange={handleChange}
              value={formData.goodsOperationalId}
              fullWidth
              variant="outlined"
              SelectProps={{
                MenuProps: {
                  PaperProps: {
                    onScroll: loadMore(1),
                  },
                  style: {
                    height: "300px",
                  },
                },
              }}
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            >
              {formData.nameOfGoods && formData.goodsOperationalId.length > 0 && (
                <MenuItem value={formData.goodsOperationalId} key={0}>
                  {formData.nameOfGoods}
                </MenuItem>
              )}
              {goodsOperational.docs.length > 0 ? (
                goodsOperational.docs.map((data, index) => (
                  <MenuItem value={data._id} key={index}>
                    {data.nameOfGoods}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">Data kosong</MenuItem>
              )}
            </TextField>
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK MASUK
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={formData.stockOut > 0}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockIn"
              onChange={handleChange}
              value={formData.stockIn}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: formData.stockOut.length > 0 ? "#e0e0e0" : "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK KELUAR
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              disabled={formData.stockIn > 0}
              required
              size="small"
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockOut"
              onChange={handleChange}
              value={formData.stockOut}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: formData.stockIn.length > 0 ? "#e0e0e0" : "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              STOCK TOTAL
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              inputProps={{ readOnly: true }}
              InputProps={{
                inputComponent: NumberFormatting,
                endAdornment: <InputAdornment position="end"></InputAdornment>,
              }}
              error={false}
              name="stockTotal"
              onChange={handleChange}
              value={formData.stockTotal}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <FormControl
            style={{
              display: "flex",
              alignItems: "center",
              justifyItems: "flex-start",
              width: "100%",
              margin: "10px 0px",
              flexDirection: "row",
              background: "none",
            }}
          >
            <Typography
              fontSize={14}
              color={"#2e473f"}
              variant="h6"
              width="16%"
            >
              KETERANGAN
            </Typography>
            <TextField
              InputLabelProps={{ shrink: true }}
              required
              size="small"
              error={false}
              name="description"
              onChange={handleChange}
              value={formData.description}
              variant="outlined"
              fullWidth
              style={{
                maxWidth: "400px",
                background: "white",
                marginRight: "10px",
              }}
            />
          </FormControl>

          <div className={styles.footerButton}>
            <Button variant="contained" type="submit">
              SUBMIT
            </Button>
            <Button
              variant="contained"
              color="error"
              style={{ marginLeft: "10px" }}
              onClick={() => navigate("/admin/stock-barang-operational")}
            >
              KEMBALI
            </Button>
          </div>
        </form>
      </Card>
    </Grid>
  );
}
